import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks, siteMeta } from "@/mocks/site";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.search]);

  const isActive = (to: string) => {
    const target = to.split("?")[0];
    if (target === "/") return location.pathname === "/";
    return location.pathname.startsWith(target);
  };

  return (
    <header
      className={`sticky top-0 z-50 border-b transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-background-200"
          : "bg-background-50 border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="h-16 md:h-[72px] flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 group">
            <span className="w-9 h-9 md:w-10 md:h-10 rounded-xl bg-primary-500 text-background-50 flex items-center justify-center transition-transform group-hover:-rotate-6">
              <i className="ri-fire-fill text-lg md:text-xl"></i>
            </span>
            <span className="font-logo text-2xl md:text-[26px] leading-none text-foreground-950">
              {siteMeta.name}
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  isActive(link.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-600 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/submit"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-bold whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              <i className="ri-send-plane-fill"></i>
              我要投稿
            </Link>
          </div>

          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 rounded-lg flex items-center justify-center text-foreground-800 hover:bg-background-100 transition-colors"
          >
            <i className={open ? "ri-close-line text-2xl" : "ri-menu-3-line text-2xl"}></i>
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50">
          <nav className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive(link.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/submit"
              className="mt-2 inline-flex items-center justify-center gap-1.5 px-5 py-3 rounded-lg bg-primary-500 text-background-50 text-sm font-bold"
            >
              <i className="ri-send-plane-fill"></i>
              我要投稿
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}